import * as types from './actionTypes';
import { PopupType, PopupDescription } from 'store/popup/util';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'store/reducer';
import { Action } from 'redux';
import { Result } from 'util/result';

export const showLoading = (message?: string) => {
  return {
    type: types.TOGGLE_POPUP,
    visible: true,
    popupType: PopupType.Loading,
    message: message,
  } as types.TogglePopupAction;
};

export const showSuccess = (message?: string) => {
  return {
    type: types.TOGGLE_POPUP,
    visible: true,
    popupType: PopupType.Success,
    message: message,
  } as types.TogglePopupAction;
};

export const showError = (message?: string) => {
  return {
    type: types.TOGGLE_POPUP,
    visible: true,
    popupType: PopupType.Error,
    message: message,
  } as types.TogglePopupAction;
};

export const showWarning = (message?: string) => {
  return {
    type: types.TOGGLE_POPUP,
    visible: true,
    popupType: PopupType.Warning,
    message: message,
  } as types.TogglePopupAction;
};

export const showPopup = (desc: PopupDescription) => {
  return {
    type: types.TOGGLE_POPUP,
    ...desc,
  } as types.TogglePopupAction;
};

export const hidePopup = () => {
  return {
    type: types.TOGGLE_POPUP,
    visible: false,
    popupType: PopupType.Loading, // just dummy type
  } as types.TogglePopupAction;
};

export enum LoadingDisplayFlag {
  ShowLoading = 0,
  ShowSuccess = 1 << 0,
  ShowError = 1 << 1,
  ShowAll = 0 | (1 << 0) | (1 << 1),
}

function flagCheck(
  source: LoadingDisplayFlag,
  target: LoadingDisplayFlag
): boolean {
  return (source & target) === target;
}

export const showLoadingAndRun = (
  action: ThunkAction<any, any, any, any>,
  displayFlags: LoadingDisplayFlag = LoadingDisplayFlag.ShowLoading |
    LoadingDisplayFlag.ShowError
): ThunkAction<void, RootState, unknown, Action<string>> => async (
  dispatch,
  getState,
  extraArguments
) => {
  if (flagCheck(displayFlags, LoadingDisplayFlag.ShowLoading)) {
    dispatch(showLoading());
  }
  const result: Result<any> = await action(dispatch, getState, extraArguments);

  if (flagCheck(displayFlags, LoadingDisplayFlag.ShowLoading)) {
    dispatch(hidePopup());
  }

  if (result) {
    if (result.isSuccess()) {
      if (flagCheck(displayFlags, LoadingDisplayFlag.ShowSuccess)) {
        dispatch(showSuccess());
      }
    } else {
      if (flagCheck(displayFlags, LoadingDisplayFlag.ShowError)) {
        dispatch(showError(result.exception()!.message));
      }
    }
  }

  return result;
};
